// ════════════ Leads.js ════════════
import React, { useEffect, useState } from 'react';
import { getLeads, addLead, followUpLead, convertLead } from '../utils/api';
import { PageTitle, Card, Table, Btn, Input, Loading, Empty, statusBadge, Grid, StatCard } from '../components/UI';

export default function Leads() {
  const [data, setData] = useState({ stats: {}, leads: [] });
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({ name: '', phone: '', email: '' });

  const load = () => getLeads()
    .then(r => {
      const result = r.data?.data || {};
      setData({
        stats: result.stats || {},
        leads: Array.isArray(result.leads) ? result.leads : Object.values(result.leads || {}),
      });
    })
    .catch(console.error)
    .finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const handleAdd = async () => {
    if (!form.name) return;
    await addLead(form).catch(console.error);
    setForm({ name: '', phone: '', email: '' });
    load();
  };

  const s = data.stats || {};

  return (
    <div>
      <PageTitle title="🎯 Leads" sub="সব leads এবং follow-up status" />
      <Grid cols={4}>
        <StatCard label="Total" value={s.total || 0} color="#a29bfe" />
        <StatCard label="New" value={s.new || 0} color="#74b9ff" />
        <StatCard label="Contacted" value={s.contacted || 0} color="#ffd200" />
        <StatCard label="Converted" value={s.converted || 0} color="#55efc4" />
      </Grid>
      <Card>
        <div style={{ fontWeight: 700, marginBottom: 16 }}>Manual Lead যোগ করো</div>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 12, alignItems: 'flex-end' }}>
          <Input label="Name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} />
          <Input label="Phone" value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder="01XXXXXXXXX" />
          <Input label="Email" value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} />
          <Btn onClick={handleAdd} style={{ marginBottom: 16 }}>+ Add Lead</Btn>
        </div>
      </Card>
      <Card>
        {loading ? <Loading /> : (data.leads || []).length === 0 ? <Empty msg="কোনো lead নেই" /> : (
          <Table
            headers={['Name', 'Phone', 'Status', 'Follow-ups', 'Actions']}
            rows={(data.leads || []).map((l, i) => (
              <tr key={i}>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontWeight: 600 }}>{l.name}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 13, color: '#6b6b80' }}>{l.phone}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e' }}>{statusBadge(l.status)}</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', fontSize: 13 }}>{l.followUpCount || 0} / 3</td>
                <td style={{ padding: '12px 16px', borderBottom: '1px solid #1e1e2e', display: 'flex', gap: 8 }}>
                  <Btn color="#a29bfe" onClick={() => followUpLead(l.id).then(load)} style={{ fontSize: 11, padding: '5px 10px' }}>📱 Follow-up</Btn>
                  {l.status !== 'CONVERTED' && <Btn color="#55efc4" onClick={() => convertLead(l.id).then(load)} style={{ fontSize: 11, padding: '5px 10px' }}>✅ Convert</Btn>}
                </td>
              </tr>
            ))}
          />
        )}
      </Card>
    </div>
  );
}
